// Ícones para as fontes fixas
import GoogleIcon from "../components/GoogleIcon";
import FacebookIcon from "../components/FacebookIcon";
import ListIcon from "../components/ListIcon";
import NatureIcon from "../components/NatureIcon";
import RepeatIcon from "../components/RepeatIcon";
import ShareIcon from "../components/ShareIcon";
import SecurityIcon from "@material-ui/icons/Security";

// Função global para mapear fontes fixas com ícones e cores
export const getSourceIcon = (sourceName) => {
    const iconMap = {
        "Google": { icon: GoogleIcon, color: "#4285F4", bgColor: "#FFFFFF" },
        "Meta": { icon: FacebookIcon, color: "#1877F2", bgColor: "#1877F2" },
        "Lista": { icon: ListIcon, color: "#9C27B0", bgColor: "#9C27B0" },
        "Admin": { icon: SecurityIcon, color: "#FFD700", bgColor: "#FFD700", isAdmin: true },
        "Orgânico": { icon: NatureIcon, color: "#4CAF50", bgColor: "#4CAF50" },
        "Recorrente": { icon: RepeatIcon, color: "#FF9800", bgColor: "#FF9800" },
        "Repasse": { icon: ShareIcon, color: "#F44336", bgColor: "#F44336" }
    };
    return iconMap[sourceName] || null;
};

// Função para obter apenas o ícone (compatibilidade com código existente)
export const getSourceIconComponent = (sourceName) => {
    const sourceInfo = getSourceIcon(sourceName);
    return sourceInfo ? sourceInfo.icon : null;
};

// Função para obter apenas a cor de fundo
export const getSourceColor = (sourceName) => {
    const sourceInfo = getSourceIcon(sourceName);
    return sourceInfo ? sourceInfo.bgColor : "#1976d2";
};

// Função para obter apenas a cor do ícone
export const getSourceIconColor = (sourceName) => {
    const sourceInfo = getSourceIcon(sourceName);
    return sourceInfo ? sourceInfo.color : "white";
};

// Função para verificar se é fonte Admin
export const isAdminSource = (sourceName) => {
    const sourceInfo = getSourceIcon(sourceName);
    return sourceInfo ? sourceInfo.isAdmin : false;
};
